import webuiState from "../app/InternalStateService";
import translationService from "../app/TranslationService";
import { validate } from "../utils/validations";
import {
    getEntityPath,
    extractStorePath,
    getDependentPaths,
    getUiStatePaths
} from "../utils/storeUtils";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

//validate siren action
//validate all widget data or entities
//validate step data or step entities
// let {
//     id = "POST",
//     actionType = "validate",
//     //target dependencies for validating data data and triggering loading animation
//     //default: [currentWidget]
//     targetDependencies = [],
//     //"local", "global", "none"
//     //default: "none"
//     loadingType = "local"
// } = action;
//TODO manage loading animation if needed - the validation performance is really fast
export function validateData(action, widgetId, currentPath) {
    let defaultConfig = webuiState.getActionsDefaultConfig({ widgetId })["validate"] || {};
    return (dispatch, getState) => {
        let state = getState();

        let targetDependencies = action.targetDependencies || action.targets || [];

        //let { targetDependencies = [] } = action;

        let validationPaths = [widgetId];
        //in flow context the id is different than the flow class
        let widgetClass = state.getIn(["data", widgetId, "class", 0]);
        let widgetActions = state.getIn(["data", widgetId, "actions"]) || [];
        let getAvailableStepsAction = widgetActions.find(
            action => action.get("actionType") === "getAvailableSteps"
        );
        //check for flow context and dependencies paths starting with step entity name
        if (!!getAvailableStepsAction) {
            let currentStepEntity = currentPath.split(".")[1];
            targetDependencies = targetDependencies.map(dependency => {
                if (dependency.startsWith(currentStepEntity)) {
                    return widgetClass + "." + dependency;
                }
                return dependency;
            });
            validationPaths = [widgetClass + "." + currentStepEntity];
        }

        //case there are dependencies provided
        if (targetDependencies.length) {
            validationPaths = targetDependencies;
        }
        let actionProperties = action.properties || {};
        //reset validations
        if (actionProperties.reset) {
            return dispatch(resetValidations(validationPaths, widgetId, currentPath));
        }

        let validationResult = dispatch(
            validateDependencies(validationPaths, currentPath, state, widgetId)
        );
        let actionMessageFlag = defaultConfig.triggerMessage;

        if (actionProperties.hasOwnProperty("triggerMessage")) {
            actionMessageFlag = action.triggerMessage;
        }

        if (!validationResult) {
            if (actionMessageFlag) {
                return Promise.reject(
                    dispatch(
                        webuiState.getActionByName("messages.triggerErrorMessage")({
                            type: "error",
                            message: translationService.translate("enterValidInfo")
                        })
                    )
                );
            }

            return Promise.reject("validate action: dependencies validation failed.");
        }

        return Promise.resolve();
    };
}
//validation state will be set in the uiState store part
//because of the specific format of the entities computedBindTo in the flow context
//we need to pass the correct widget id
export function validateWidgetData(data, widgetId) {
    return dispatch => {
        if (!data) {
            WEBUILogs.error("Missing data.");
            return false;
        }
        return dispatch(validateEntity(data, [widgetId]));
    };
}

export function validateStepData(stepData, stepIndex, widgetId) {
    return dispatch => {
        if (!stepData) {
            WEBUILogs.error("Missing step data.");
            return false;
        }
        return dispatch(validateEntity(stepData, [widgetId, "entities", stepIndex]));
    };
}

export function validateEntity(data, storePath) {
    const triggerMultipleSetUiState = webuiState.getActionByName(
        "component.triggerMultipleSetUiState"
    );
    return (dispatch, getState) => {
        let { validations, validationSuccess } = validate(data, storePath);
        //@returned validation format:[{path:[truePath],state: {valid: false, failedMessages: {...}}}, ...]
        if (validations.length) {
            dispatch(webuiState.getActionByName("component.triggerMultipleSetData")(validations));
            //ui state needs container computedBindTo
            let computedPathUiState = validations.map(state => {
                if (state.hasOwnProperty("path")) {
                    let widgetId = state.path[0]; // by default the true path first item is the widget id
                    let computedBindTo = getEntityPath(state.path, getState());
                    return Object.assign({}, state, { path: [widgetId, computedBindTo] });
                }
                return state;
            });
            dispatch(triggerMultipleSetUiState(computedPathUiState));
        }
        return validationSuccess;
    };
}

export function resetValidations(targets = [], currentWidgetId, currentPath) {
    const clearUiStateValidationsDeep = webuiState.getActionByName(
        "component.clearUiStateValidationsDeep"
    );
    return (dispatch, getState) => {
        let state = getState();
        let dependencyItems = getUiStatePaths(targets, state, currentPath, currentWidgetId);

        dependencyItems.forEach(targetDependency => {
            dispatch(clearUiStateValidationsDeep(targetDependency[0], targetDependency[1]));
        });

        //return Promise.resolve();
    };
}

//revalidates only entities with failed validations
//for full validaiton use validateEntity
export function revalidateEntities(widgetId, options = {}) {
    const triggerMultipleSetUiState = webuiState.getActionByName(
        "component.triggerMultipleSetUiState"
    );
    const setUiState = webuiState.getActionByName("component.setUiState");
    return (dispatch, getState) => {
        let path = getState().getIn(["data", widgetId, "class", 0]);
        if (options.entityPath) {
            path = options.entityPath;
        }
        let uiState = getState()
            .getIn(["uiState", widgetId])
            .toJS();

        //build not valid keys
        let notValidUiStateKeys = Object.keys(uiState).filter(key => {
            //revalidates only entities with failed validations
            return key.startsWith(path) && uiState[key]["valid"] === false;
        });
        //check if there are failed validations
        if (notValidUiStateKeys.length === 0) {
            return;
        }
        notValidUiStateKeys.forEach(key => {
            let storePath = extractStorePath(key, getState());
            if (storePath.length) {
                let entityDataImmutable = getState().getIn(["data", ...storePath]);
                let entityData = entityDataImmutable ? entityDataImmutable.toJS() : {};
                let { validations } = validate(entityData, storePath);
                if (validations.length) {
                    dispatch(
                        webuiState.getActionByName("component.triggerMultipleSetData")(validations)
                    );
                    //ui state needs container computedBindTo
                    let computedPathUiState = validations.map(state => {
                        if (state.hasOwnProperty("path")) {
                            let widgetId = state.path[0]; // by default the true path first item is the widget id
                            let computedBindTo = getEntityPath(state.path, getState());
                            return Object.assign({}, state, { path: [widgetId, computedBindTo] });
                        }
                        return state;
                    });
                    dispatch(triggerMultipleSetUiState(computedPathUiState));
                } else {
                    dispatch(setUiState(widgetId, key, { valid: true, failedValidations: {} }));
                }
            }
        });
    };
}

function validateDependencies(dependencies = [], currentPath, state, widgetId) {
    return dispatch => {
        let result = true;
        let storePaths = getDependentPaths(dependencies, state, currentPath, widgetId);
        storePaths.forEach(storePath => {
            let entityDataImmutable = state.getIn(["data", ...storePath]);
            let entityData = entityDataImmutable ? entityDataImmutable.toJS() : {};
            let validDependency = dispatch(validateEntity(entityData, storePath));
            result = result && validDependency;
        });
        return result;
    };
}
